import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { APP_SETTINGS, AppSettings, ROOT_REDUCERS } from './app-settings';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigManagerService } from './shared/services/config-manager.service';
import { StoreModule } from '@ngrx/store';
import {
    provideNgxWebstorage,
    withLocalStorage,
    withSessionStorage,
    withNgxWebstorageConfig
} from 'ngx-webstorage';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { extModules } from './build-specifics';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from './auth/auth.module';
import { LayoutModule } from './layouts/layout.module';
import { CoreModule } from './shared/core.module';
import { UtilModule } from './utils/store/utils.module';
import { AlertModule } from './alerts/store/alert.module';
import { ErrorModule } from './error/error.module';
import { UserPermissionsService } from './shared/services/user-permissions.service';
import { SingletonServicesModule } from './singleton-services/singleton-services.module';
import { metaReducers } from './store/store.metareducers';

export function configManagerServiceFactory(
    configManager: ConfigManagerService
): Function {
    return () => configManager.init();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        // Angular Modules
        BrowserModule,
        HttpClientModule,

        // Quotient Modules
        AlertModule,
        UtilModule,
        CoreModule,
        SingletonServicesModule,
        LayoutModule,
        ErrorModule,
        AuthModule,
        AppRoutingModule, // App routing should always be last for route matching hierarchy

        //Vendor Modules
        StoreModule.forRoot(ROOT_REDUCERS, {
            metaReducers
        }),
        EffectsModule.forRoot([]),
        ...extModules,
        StoreRouterConnectingModule.forRoot(),
        BrowserAnimationsModule
    ],
    providers: [
        ConfigManagerService,
        {
            provide: APP_INITIALIZER,
            useFactory: configManagerServiceFactory,
            deps: [ConfigManagerService],
            multi: true
        },
        {
            provide: APP_SETTINGS,
            useValue: AppSettings
        },
        UserPermissionsService,
        provideNgxWebstorage(
            withNgxWebstorageConfig({ prefix: 'qss' }),
            withLocalStorage(),
            withSessionStorage()
        )
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
